import { gql } from "@apollo/client";

export const AddInstalledBaseNodeToInstalledBaseAccessGroup = gql`
    mutation AddInstalledBaseNodeToInstalledBaseAccessGroup ($accessGroupId: ID!, $installedBaseNodeId: ID!, $input: InstalledBaseNodeAclAttributesInput!){
        addInstalledBaseNodeToInstalledBaseAccessGroup(installedBaseAccessGroupId: $accessGroupId, installedBaseNodeId: $installedBaseNodeId, input: $input){
            success
            message
        }
    }
`;
